<template>
  <div class="desktop">
    <div class="inner">
      <div class="top-menu">
        <div class="left">
          <div class="icon"></div>
          <div class="app-name">
            {{ appConfig.name }}
          </div>
          <div class="menus">
            <div class="menu" v-for="menu in appConfig.menus" :key="menu">
              {{ menu }}
            </div>
          </div>
        </div>
        <div class="right">
          <div class="icons">
            <img :src="require('../assets/img/wifi.svg')">
            <img :src="require('../assets/img/volume.svg')">
            <img :src="require('../assets/img/battery.svg')">
          </div>
          <div class="time">
            {{ dateDisplay }}
          </div>
          <div class="icons">
            <img :src="require('../assets/img/spotlight.svg')">
            <img :src="require('../assets/img/notifications.svg')">
          </div>
        </div>
      </div>
      <div class="viewport">
        <component :is="appConfig.component" v-if="appConfig.component" @complete="appComplete" />
      </div>
      <div class="dock">
        <div class="icon" :class="{launching: currentlyLaunching === 'Terminal', clicking: currentlyClicking === 'Terminal', running: appIsRunning('Terminal')}" @click="launch('Terminal')">
          <terminal-icon />
          <div class="active"></div>
        </div>
      </div>
    </div>
    <panic v-if="panic" />
    <mouse-cursor :animate="cursorAnimating" v-if="cursor" />
  </div>
</template>

<script>
import TerminalIcon from '@/assets/img/Terminal'
import Terminal from '@/components/Terminal'
import Panic from '@/components/Panic'
import Cursor from '@/components/Cursor'
import { sleep } from '@/utils'

const APP_CONFIG = {
  Launcher: {
    name: 'Human OS',
    menus: ['File', 'Go', 'Help']
  },
  Terminal: {
    name: 'Terminal',
    menus: ['File', 'Edit', 'Help'],
    component: Terminal
  }
}

export default {
  components: {
    TerminalIcon,
    Panic,
    MouseCursor: Cursor
  },
  data () {
    return {
      currentApp: 'Launcher',
      currentlyLaunching: null,
      currentlyClicking: null,
      cursorAnimating: false,
      panic: false,
      cursor: true,
      date: new Date()
    }
  },
  computed: {
    appConfig () {
      return APP_CONFIG[this.currentApp]
    },
    dateDisplay () {
      return "August 1992"
    }
  },
  methods: {
    ready () {
      this.run()
    },
    async run () {
      await sleep(1500)
      this.cursorAnimating = true
      await sleep(3000)
      this.currentlyClicking = 'Terminal'
      await sleep(100)
      this.currentlyClicking = null
      this.launch('Terminal')
    },
    appIsRunning (name) {
      return this.currentApp === name
    },
    launch (name) {
      if(this.currentApp === name) return
      this.currentlyLaunching = name
      setTimeout(() => {
        this.currentApp = name
        this.currentlyLaunching = null
      }, 1000)
    },
    appComplete () {
      if(this.currentApp === 'Terminal') {
        this.panic = true
        this.cursor = false
      }
    }
  },
  mounted () {
    this.ready()
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/mixins";

.desktop {
  width: 100%;
  height: 100%;
  background-color: black;
  position: relative;

  .inner {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    background: url('/background.jpg') center center no-repeat;
    background-size: cover;
    @include animation(fade-in 1.8s);
  }

  .top-menu {
    background-color: rgba(255, 255, 255, 0.75);
    height: 25px;
    font-size: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @include box-shadow(0, 2px, 10px, rgba(0, 0, 0, 0.1));

    .left, .right {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }

    .right {
      .icons {
        display: flex;
        flex-direction: row;
        align-items: center;

        img {
          margin-right: 15px;
        }
      }
    }

    .time {
      margin-right: 20px;
    }

    .icon {
      margin-right: 20px;
    }

    .app-name {
      font-weight: bold;
      margin-right: 20px;
    }

    .menus {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      text-overflow: ellipsis;
      overflow: hidden;

      .menu {
        margin-right: 10px;
      }
    }
  }

  .viewport {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .dock {
    align-self: center;
    border: 1px solid rgba(137, 158, 177, 0.5);
    margin-bottom: -1px;
    @include css3-prefix(backdrop-filter, blur(50px));
    @include background-gradient(rgba(137, 158, 177, 0.95), rgba(137, 158, 177, 0.45));
    @include css3-prefix(border-top-left-radius, 3px);
    @include css3-prefix(border-top-right-radius, 3px);

    .icon {
      margin-top: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .active {
        margin-bottom: 3px;
        width: 4px;
        height: 4px;
        background-color: black;
        visibility: hidden;
        opacity: 0;
        @include transition(opacity 0.3s);
        @include border-radius(4px);
      }

      svg {
        margin-bottom: -5px;
      }

      &.clicking {
        filter: brightness(50%);
      }

      &.launching {
        svg {
          @include animation(bounce 1s);
          @include css3-prefix(animation-iteration-count, infinite);
          @include css3-prefix(animation-timing-function, ease-in-out);
        }
      }

      &.running {
        .active {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
}

@include keyframes(fade-in) {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@include keyframes(bounce) {
  0% {
    @include transform(translateY(0))
  }

  50% {
    @include transform(translateY(-15px))
  }

  100% {
    @include transform(translateY(0))
  }
}

@media (max-width: 600px) {
  .desktop {
    .top-menu {
      .right {
        justify-content: flex-end;
        .icons {
          display: none;
        }
      }
    }
  }
}
</style>
